import type { ApiModuleEndpoints } from '../types'

export const cashTransactionApiEndpoints = {
  transactions: {
    method: 'GET',
    path: '/cash-transactions',
    requiresAuth: true,
  },
  transactionDetail: {
    method: 'GET',
    path: '/cash-transactions/:id',
    requiresAuth: true,
  },
  createTransaction: {
    method: 'POST',
    path: '/cash-transactions',
    requiresAuth: true,
  },
  cancelTransaction: {
    method: 'POST',
    path: '/cash-transactions/:id/cancel',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
